module.exports = __webpack_public_path__ + "assets/img/dc60f2aab3f9ef173529006829f8ee57.svg";